// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SEyN5eHoZJskvhkZStnZ{flex-direction:column;gap:20px;padding:16px 0 24px;display:flex}.BOO6RH7iEQcLc8aqhsnw{align-items:center;gap:10px;padding:8px 12px}.iIvDJq9QEzk4LjJWnhZO{padding-left:12px}.DRkEDkm0Kb8ueRHwrf0n{max-width:128px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SEyN5eHoZJskvhkZStnZ`,
	"inboxPlaceholderWrap": `BOO6RH7iEQcLc8aqhsnw`,
	"description": `iIvDJq9QEzk4LjJWnhZO`,
	"selectedItem": `DRkEDkm0Kb8ueRHwrf0n`
};
export default ___CSS_LOADER_EXPORT___;
